<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
  >
    <div class="card-toolbar" before-btns>
      <!-- preview btn -->
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        mat-ripple
        (click)="previewPage()"
        [matTooltip]="'common.preview' | translate"
      >
        <i class="mdi mdi-eye mdi-20px tw-p-0 text-navyBlue"></i>
      </a>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="tw-w-full tw-flex-center tw-flex-col">
        <div class="row xl:tw-w-3/4 md:tw-w-11/12 tw-w-full">
          <!-- Form Details -->
          <section class="tw-w-full tw-mt-4">
            <fieldset class="tw-h-full">
              <legend class="tw-flex-center">
                {{ "common.formDetails" | translate }}
              </legend>

              <div class="tw-flex-center tw-flex-col tw-pb-5 tw-my-12">
                <!-- title -->
                <div class="md:tw-w-3/5 tw-w-11/12">
                  <form-field
                    class="tw-w-full"
                    [(value)]="model.title"
                    [control]="form?.get('title')"
                    label="common.title"
                  >
                  </form-field>
                </div>

                <!-- description -->
                <div class="md:tw-w-3/5 tw-w-11/12 tw-mb-6">
                  <app-ngx-editor
                    [placeHolder]="'common.description' | translate"
                    [control]="form.get('description')"
                    [html]="model?.description"
                  >
                  </app-ngx-editor>
                </div>

                <!-- Appearance Settings -->
                <forms-management-appearance-setting
                  class="tw-w-full"
                  [formBuilderThemesEnumValues]="formBuilderThemesEnumValues"
                  [selectedTheme]="model.theme"
                  [imageUrl]="imageUrl"
                  [imageLoading]="imageLoading"
                  (file)="getFile($event)"
                  (theme)="model.theme = $event"
                ></forms-management-appearance-setting>

                <!-- fields -->
                <details class="tw-pt-10 tw-px-4 tw-w-full" [open]="true">
                  <summary
                    class="active:tw-outline-none dark:tw-text-gray-300 focus:tw-outline-none tw-font-bold tw-mb-2 tw-text-[18px] tw-text-primary-700 tw-text-right"
                  >
                    {{ "common.fields" | translate }}
                  </summary>

                  <div class="tw-flex-center tw-flex-col tw-w-full">
                    <div
                      class="2xl:tw-w-4/5 lg:tw-w-full xl:tw-w-[85%] tw-flex tw-w-full tw-justify-end tw-items-end"
                    >
                      <button
                        (click)="openFieldsManagementFormDialog()"
                        class="tw-mb-3 tw-bg-teal-500 hover:tw-bg-teal-600 tw-h-12 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-text-white tw-w-28 tw-cursor-pointer"
                      >
                        {{ "common.newFiled" | translate }}
                      </button>
                    </div>
                    
                    <!-- add field -->
                    <div class="2xl:tw-w-4/5 lg:tw-w-full xl:tw-w-[85%] tw-flex tw-w-full">
                      @if (model.fields?.length>0) {

                      <!--* fields -->
                      <div
                        class="tw-flex md:tw-flex-row tw-flex-col md:tw-items-start tw-items-center"
                      >
                        <!-- fields list -->
                        <div
                          class="tw-flex-center md:tw-flex-col md:tw-w-2/5 md:tw-flex-nowrap tw-flex-wrap tw-my-3"
                          cdkDropList
                          cdkDropListOrientation="mixed"
                          (cdkDropListDropped)="drop($event)"
                        >
                          @for (field of model.fields; track $index) {
                          <div
                            (click)="setActive(field?.id, field)"
                            #fieldElement
                            [ngClass]="
                              (
                                activeFieldsetId
                                  ? activeFieldsetId ==
                                    field?.formBuilderFieldId
                                  : $index == 0
                              )
                                ? 'tw-bg-primary-50 dark:tw-bg-primary-900/40 tw-border-primary-200 dark:tw-border-primary-400 tw-text-primary-400 tw-border'
                                : 'tw-bg-gray-200 dark:tw-bg-dark-100 tw-text-gray-600 dark:tw-text-gray-300'
                            "
                            class="tw-h-12 tw-relative tw-flex tw-items-center tw-ml-2 tw-mb-2 tw-font-medium tw-rounded-lg tw-cursor-pointer tw-w-[200px] tw-justify-between"
                            cdkDrag
                          >
                            <!-- field type icon -->
                            @if(field?.fieldType) {
                            <i
                              [matTooltip]="
                                field.fieldType
                                  | enumToText : formBuilderFieldTypesEnumValues
                              "
                              [fieldTypeIcon]="field.fieldType"
                              [style.color]="
                                (
                                  activeFieldsetId
                                    ? activeFieldsetId ==
                                      field?.formBuilderFieldId
                                    : $index == 0
                                )
                                  ? '#5467d0'
                                  : ''
                              "
                            ></i>
                            } @else {
                            <div></div>
                            }

                            <!-- field title -->
                            <span
                              class="tw-mx-2 tw-text-base tw-font-semibold tw-whitespace-nowrap"
                            >
                              {{ field?.formBuilderFieldTitle }}
                            </span>

                            <!-- delete field -->
                            <i
                              (click)="onRemoveField(field?.formBuilderFieldId)"
                              [matTooltip]="'common.delete' | translate"
                              class="mdi mdi-delete mdi-21px tw-text-gray-400 hover:tw-text-red-500 tw-opacity-70 hover:tw-opacity-100 tw-mx-2"
                            ></i>

                            <!-- active field icon -->
                            @if( ( activeFieldsetId ? activeFieldsetId ==
                            field?.formBuilderFieldId : $index == 0 )){
                            <i
                              [style.color]="
                                (
                                  activeFieldsetId
                                    ? activeFieldsetId ==
                                      field?.formBuilderFieldId
                                    : $index == 0
                                )
                                  ? '#5467d0'
                                  : ''
                              "
                              class="mdi mdi-menu-left tw-absolute -tw-left-[33px] mdi-48px md:tw-block tw-hidden"
                            ></i>
                            }
                          </div>
                          }

                          <button
                            (click)="openCreateNewFieldDialog()"
                            class="mat-ripple tw-flex-center btn tw-ml-2 button-shadow btn-hover-rise tw-bg-indigo-500 tw-text-white hover:tw-text-white tw-rounded-lg tw-w-[200px] tw-h-12 tw-mb-2"
                          >
                            <span>{{ "common.add" | translate }}</span>
                            <i
                              class="mdi mdi-plus mdi-20px tw-px-2 tw-text-white"
                            ></i>
                          </button>
                        </div>

                        <!-- form fields -->
                        <div
                          class="md:tw-w-3/5 tw-border dark:tw-border-dark-100 tw-p-4 tw-rounded-lg"
                        >
                          <app-fields
                            [formBuilderFieldsList]="formBuilderFieldsList"
                            [formPageConfig]="formPageConfig"
                            [field]="activeField"
                            (fields)="setFields($event)"
                          >
                          </app-fields>
                        </div>
                      </div>

                      } @else {
                      <!-- add field btn when no fields -->
                      <div class="tw-w-full">
                        <button
                          (click)="openCreateNewFieldDialog()"
                          [matTooltip]="
                            'common.addFromExistingFields' | translate
                          "
                          class="tw-border-2 tw-border-dashed tw-border-primary-300 tw-flex-center tw-h-24 tw-rounded-lg tw-w-full tw-mt-5 tw-cursor-pointer hover:tw-bg-primary-50 hover:dark:tw-bg-primary-900/50"
                        >
                          <i
                            class="mdi mdi-plus mdi-40px tw-text-primary-300"
                          ></i>
                        </button>
                      </div>
                      }
                    </div>
                  </div>
                </details>
              </div>
            </fieldset>
          </section>
        </div>

        <!-- form btns-->
        <div class="tw-w-3/4 tw-px-3">
          <app-form-btns
            [loading]="loading"
            [form]="form"
            [isEdit]="formPageConfig.isEditMode"
            (onClose)="onClose()"
            (onSubmit)="onSubmit()"
          >
          </app-form-btns>
        </div>
      </div>
    </form>
  </div>
</app-page-body>
